import { cB, cM } from '../../../_utils/cssr'

export default cB('collapse-transition', [
  cM('rtl', `
    direction: rtl;
    text-align: right;
  `)
])
